import { useCallback } from 'react';
import { Quill } from 'seagull/patches/PatchedQuill';
import { isSystemVariable, normalizeVariableLabel } from '../TemplateVariables.utils';
import '../TemplateVariableBlot/TemplateVariableBlot';
export function useInsertVariableIntoQuill(editorElRef, resolvedValues) {
    return useCallback((label)=>{
        const editorEl = editorElRef.current;
        if (!editorEl) return;
        const quill = Quill.find(editorEl);
        if (!quill) return;
        const range = quill.getSelection(true);
        if (range.length > 0) {
            quill.deleteText(range.index, range.length, 'user');
        }
        const hasValue = !!resolvedValues[normalizeVariableLabel(label)];
        const needsSetup = !isSystemVariable(label) && !hasValue;
        quill.insertEmbed(range.index, 'template-variable', {
            label,
            setup: needsSetup
        }, 'user');
        quill.setSelection(range.index + 1, 0, 'silent');
    }, [
        editorElRef,
        resolvedValues
    ]);
}
